import { BackupPolicyType } from '@repo/api-gw-sdk';
import type { PropsWithChildren } from 'react';

import { StepContainer } from '@/components/wizard/StepContainer';
import type { StepProps } from '@/components/wizard/StepProps';
import { RenameEntityName } from '@/components/wizard/renameEntityName';

import type { BackupPolicyEditState } from './BackupPolicyCreationFlow';

export const BackupPolicySettingsStepContainer = (
  props: PropsWithChildren<
    StepProps<BackupPolicyEditState> & {
      canGoNext: () => boolean;
      nextButtonDisabledTooltip?: string;
    }
  >
) => {
  const defaultTooltip =
    props.wizardState.policyType === BackupPolicyType.BACKUP_POLICY_TYPE_PITR
      ? 'Make sure all fields are filled in, and that PiTR schedules meet the necessary requirements'
      : 'Please complete all required fields';

  return (
    <StepContainer
      canGoNext={props.canGoNext}
      sx={{ padding: 0 }}
      navigationComponent={
        <RenameEntityName
          label='Backup policy name'
          name={props.wizardState.name}
          onSubmit={(name) =>
            props.setWizardState((state) => ({ ...state, name }))
          }
        />
      }
      stepperLabels={props.stepperLabels}
      stepperIndex={2}
      onBackClick={props.back}
      nextButtonDisabledTooltip={
        props.nextButtonDisabledTooltip || defaultTooltip
      }
      nextButtonText={props.wizardState.id ? 'Save Changes' : 'Create'}
      onNextClick={props.finish}
    >
      {props.children}
    </StepContainer>
  );
};
